module.exports = ['$rootScope', '$state', '$stateParams', '$http', function ($scope, $state, $stateParams, $http) {
    var loading = false;
    var initialLoad = false;
    var previousCount = window.localStorage.getItem('MG.previousCount');

    var loadResults = function (limit) {
        var searchParams = $stateParams;
        var itemQueryString = '';

        loading = true;

        // build query string based on params
        angular.forEach(Object.keys(searchParams), function (param) {
            var paramValue = searchParams[param];
            if (typeof (paramValue) !== 'undefined') {
                itemQueryString += param + '=' + paramValue + '&';
            }
        });

        // add in pagination related params
        itemQueryString += 'limit=' + limit + '&offset=' + $scope.offset;

        $http.get('/api/fabricationitem?' + itemQueryString)
        .then(function (res) {

            loading = false;
            initialLoad = true;

            angular.forEach(res.data.items, function (x) {
                $scope.results.push({
                    title: x.title,
                    image: x.image,
                    link: x.link,
                    content: x.content
                });
            });

            // if count is specified in url scroll user to bottom of page
            if (limit <= 12) {
                $scope.count = $scope.offset + limit;
                window.localStorage.setItem('MG.previousCount', $scope.count);
            }

            // update offset (number of currently shown results)
            $scope.offset = $scope.offset + limit;

            // update product count in sidebar
            $scope.productCount = res.data.total;
        });
    };

    if (previousCount === null) {
        $scope.count = 0;
    } else {
        $scope.count = parseInt(previousCount);
    }

    // initialize default options
    $scope.offset = 0;
    $scope.results = [];


    $scope.showLoading = function () {
        return loading;
    };

    $scope.showLoadMore = function () {
        return !loading && initialLoad && $scope.results.length < $scope.productCount;
    };

    $scope.showNoResults = function () {
        return !loading && initialLoad && $scope.results.length === 0;
    };

    $scope.loadMore = function ($event) {
        $event.preventDefault();
        loadResults(12);
    };

    if (!initialLoad && MG.previousPath.indexOf('/fabrication-product/') === 0 && $scope.count > 12) {
        loadResults($scope.count);
    } else {
        loadResults(12);
    }
}];